let userId = JSON.parse(localStorage.getItem('userId'));
export const CATEGORY =
  '/catalogs/vaccineShoppeUSProductCatalog/Online/categories/1';
export const VAXCATEGORY =
  '/catalogs/vaxserveProductCatalog/Online/categories/1';
export const VALIDATE_EMAIL = '/forgotten-username-password/validate-email';
export const VALIDATE_PASSWORD_ANSWER =
  '/forgotten-username-password/validate-password-answer';
export const RESET_PASSWORD = '/forgotten-username-password/reset-password';
export const USER_NAME = '/users/current';
export const USER_ACCOUNT = '/users/';
export const ADD_CARD = '/users/current/carddetails';
export const GET_INVOICES = '/my-account/invoices';
export const DOWNLOAD_INVOICE_CREDIT_PDF = 'my-account/invoicepdf';
export const DOWNLOAD_INVOICE_PDF = 'my-account/invoice-data-pdf';
export const GET_CARD_DETAILS = '/my-account/payment-info';
export const POST_CARD_DETAILS = '/my-account/creditReview';
export const SUBMIT_CREDIT = '/my-account/payment-confirmation-credit';
export const GET_PROVINCES = '/countries/US/regions';
export const GET_STATES = '/countries/US/regions';
export const GET_PRACTICEORFACILITYTYPE = '/enumeration';
export const POST_ACCOUNT_REGISTRATION_DETAILS = '/account/register';
export const VALIDATE_ADDRESS = 'account/validateAddress';
export const INFLUENZA = '/Influenza/';
export const INFLUENZA_RECRESERVATION = 'recurring-reservation';
export const INFLUENZA_LOCATION = 'locator/flu-locator';
export const VALIDATE_ACCOUNT_INFORMATION_USER_REGISTRATION =
  '/customer-register/account-information';
export const POST_USER_REGISTRATION_INFO =
  '/customer-register/customer-information';

export const GET_CARD = '/my-account/payment-info?';

export const GET_OPEN_STATEMENTS = '/my-account/statements';
export const GET_ALL_STATEMENTS_DATA_RANGE = '/my-account/statementsDisplay';

export const GET_SEARCH_HISTORY = '/users/';

export const GET_ACCOUNT_ID = `/users/current/b2bUnits`;

export const SUBMIT_CREDIT_CARD_PAYMENT = '/my-account/ccinvoice-payment';
export const GET_ORDER_HISTORY = '/users/';
export const GET_PAYMENT_HISTORY = 'my-account/openar/paymenthistory';
export const CATALOGS = '/catalogs/';
export const CATALOGSTYPE = '/materialProduct/get-material/';
export const FAQ = '/frequently-asked-questions';
export const RESOURCES = '/toolsandresources';
export const GET_TICKET_CATEGORIES = '/ticketCategories';
export const GET_SUB_TICKET_CATEGORIES = '/ticketSubCategories';
export const GET_PRODUCT_SUGGESTIONS = '/products/suggestions';
export const account = '/account';
export const SUBMIT_REQUEST = '/materialProduct';
export const SUBMIT_RETURN = '/users/test1d3/orderReturns/submitReturn';
export const GET_USER_AGENT =
  'assisted-service/salesAgentResetPassword/';
export const SEND_USER_MAIL = 'forgotten-username-password/asm-reset-password';
export const REPORTS = 'report/dashboard';
export const REPORTDETAILS = 'report/';
export const GET_REORDER_DATA = '/catalogs/reorderData';
export const GET_OFFERS = 'offers';